import { getInitialState as getInitialStateUserPreferences } from '../../../../global-store/subjects/user-preferences';
import { getLabel } from '../../../../labels/labelling-service';
import { satelliteTracker } from '../../../../services/tracking/satellite-tracking-service';
import { getHomePageUrl } from '../../../../utils/aem-utils';
import { allowBodyScroll, preventBodyScroll } from '../../../../utils/body-scroll';
import { getLoginUrl } from '../../../../utils/build-urls';
import { doWidgetMutation, doWidgetQuery } from '../api';

const getHandleOptionInPageClick =
  ({ state, actions, pageActions, htmlProps: { maxOptions } }) =>
  (option, blockType) => {
    const optionIsAlreadySubscribed = state.dataSubscriptions.list
      .filter((newsletter) => newsletter.isSubscribed)
      .map((newsletter) => newsletter.id)
      .includes(option.id);

    if (optionIsAlreadySubscribed) {
      actions.showUnsubscribeModal(true);
      return;
    }

    let newSelectedOptionsIds;
    const optionIsAlreadySelected = state.selectedOptionsIds.includes(option.id);
    if (maxOptions === 1) {
      newSelectedOptionsIds = optionIsAlreadySelected ? [] : [option.id];
    } else {
      newSelectedOptionsIds = optionIsAlreadySelected
        ? state.selectedOptionsIds.filter((selectedOption) => selectedOption !== option.id)
        : [...state.selectedOptionsIds, option.id];
    }
    actions.selectNewsletters(newSelectedOptionsIds);
    pageActions.setConfirmBottomDialog({
      isShown: true,
      ctaPrimaryLabel: getLabel('newsletters.confirm.label'),
    });
    pageActions.setActiveBlock(blockType);
  };

const getHandleInfoClick =
  ({ widget, actions, state, pageActions }) =>
  () => {
    pageActions.setConfirmBottomDialog({ isShown: false });
    pageActions.setActiveBlock(getInitialStateUserPreferences().activeBlock);
    actions.selectNewsletters(
      state.dataSubscriptions.list.filter((newsletter) => newsletter.isSubscribed).map((newsletter) => newsletter.id)
    );
    pageActions.setModalTooltip({ widgetId: widget.htmlId });
  };

const getHandleCtaSignupClick =
  ({ state, actions, htmlProps, widget }) =>
  (isUserLogged) => {
    if (!isUserLogged) {
      satelliteTracker.trackInWeb('newsletter_richiesta_iscrizione');
      window.location.href = getLoginUrl(window.location.href);
    }
    const isSubscribed = state.dataSubscriptions?.list.filter(
      (newsletter) => newsletter.id === htmlProps.listId && newsletter.isSubscribed
    ).length;
    if (isUserLogged && isSubscribed) {
      window.location.href = getHomePageUrl();
    }
    if (isUserLogged && !isSubscribed) {
      const trackingTopic = window.digitalData?.page?.pageInfo?.pageName?.split(':')?.pop();
      satelliteTracker.trackInWeb('newsletter_conferma_iscrizione', { status: 'iscritto nl', topic: trackingTopic });
      const onSuccessCallback = () => doWidgetQuery({ widget, listIds: [htmlProps.listId], actions });
      doWidgetMutation({ widget, listId: htmlProps.listId, actions, onSuccessCallback });
    }
  };

const getHandleOpenNewslettersFullScreen = (actions) => () => {
  actions.showNewslettersFullScreen(true);
  preventBodyScroll('MOBILE');
};

const getHandleCloseNewslettersFullScreen =
  ({ state, actions, pageActions }) =>
  () => {
    actions.showNewslettersFullScreen(false);
    actions.selectNewsletters(
      state.dataSubscriptions.list.filter((newsletter) => newsletter.isSubscribed).map((newsletter) => newsletter.id)
    );
    pageActions.setConfirmBottomDialog({ isShown: false });
    pageActions.setActiveBlock(null);
    actions.showUnsubscribeModal(false);
    allowBodyScroll('MOBILE');
  };

const getHandleUnsubscribeModalClose = (actions) => () => {
  actions.showUnsubscribeModal(false);
};

export const getHandlers = ({ state, actions, widget, pageActions, htmlProps }) => ({
  handleOptionInPageClick: getHandleOptionInPageClick({ state, actions, pageActions, htmlProps }),
  handleInfoClick: getHandleInfoClick({ widget, actions, state, pageActions }),
  handleUnsubscribeModalClose: getHandleUnsubscribeModalClose(actions),
  handleCtaSignupClick: getHandleCtaSignupClick({ state, actions, htmlProps, widget }),
  handleOpenNewslettersFullScreen: getHandleOpenNewslettersFullScreen(actions),
  handleCloseNewslettersFullScreen: getHandleCloseNewslettersFullScreen({ state, actions, pageActions }),
});
